export default {
    list(state) {
        return state.list;
    },
    request(state) {
        return state.request;
    }
}